import { mutatorAction } from "satcheljs";
import { shiftRequestsPanelStore } from "../";

export default mutatorAction('SET_SELECTED_REQUEST_ID_IN_STORE', function setSelectedRequestIdInStore(selectedRequestId: string) {
    shiftRequestsPanelStore().selectedRequestId = selectedRequestId;
});
